import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ICadastroEmployee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { employeeStatusInfo } from 'src/app/shared/data/employee-status.enum';

@Component({
  selector: 'app-employee-details-modal',
  templateUrl: './employee-details-modal.component.html',
  styleUrls: ['./employee-details-modal.component.scss']
})
export class EmployeeDetailsModalComponent implements OnChanges, OnDestroy {
  @Input() employeeId?: string;
  @Output() fechar = new EventEmitter<void>();

  readonly statusInfo = employeeStatusInfo;
  employee?: ICadastroEmployee;
  carregando = false;
  erro?: string;

  private readonly destroy$ = new Subject<void>();

  constructor(private readonly employeeService: EmployeeService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['employeeId'] && this.employeeId) {
      this.carregarDetalhes(this.employeeId);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private carregarDetalhes(id: string): void {
    this.carregando = true;
    this.erro = undefined;
    this.employee = undefined;
    this.employeeService
      .detalhesColaborador(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.employee = res.data;
          this.carregando = false;
        },
        error: () => {
          this.erro = 'Não foi possível carregar os detalhes do colaborador.';
          this.carregando = false;
        }
      });
  }

  public fecharModal(): void {
    this.fechar.emit();
  }
}
